// extracted by mini-css-extract-plugin
export default {"miniWidgetIcon":"dashboard_miniWidgetIcon__9ED11"};